import { useEffect, useRef, useState } from "react";

// Animated number count-up. Resets to 0 when inactive; jumps to target under reduced motion.
export function useCountUp(target, active, { duration = 1200, reduce = false } = {}) {
  const [val, setVal] = useState(0);
  const rafRef = useRef();
  useEffect(() => {
    if (!active) {
      setVal(0);
      return;
    }
    if (reduce) {
      setVal(target);
      return;
    }
    let start;
    const step = (now) => {
      if (start === undefined) start = now;
      const p = Math.min(1, (now - start) / duration);
      const eased = 1 - Math.pow(1 - p, 3);
      setVal(Math.round(target * eased));
      if (p < 1) rafRef.current = requestAnimationFrame(step);
    };
    rafRef.current = requestAnimationFrame(step);
    return () => cancelAnimationFrame(rafRef.current);
  }, [target, active, duration, reduce]);
  return val;
}

export default useCountUp;
